module.exports = __webpack_public_path__ + "static/media/notebook.524bbf43.png";